const d = [
    {
        type: 'Feature',
        properties: {
            unique_id: '410303007',
            ext_path: '河南省 洛阳市 西工区 汉屯路街道',
            cid: '1',
            pid: '410303',
            name: '汉屯路街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.425298, 34.678678]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410303010',
            ext_path: '河南省 洛阳市 西工区 红山街道',
            cid: '2',
            pid: '410303',
            name: '红山街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.351804, 34.708472]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410303002',
            ext_path: '河南省 洛阳市 西工区 金谷园街道',
            cid: '3',
            pid: '410303',
            name: '金谷园街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.433036, 34.675222]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410303008',
            ext_path: '河南省 洛阳市 西工区 凯旋东路街道',
            cid: '4',
            pid: '410303',
            name: '凯旋东路街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.459424, 34.670225]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410303009',
            ext_path: '河南省 洛阳市 西工区 洛北街道',
            cid: '5',
            pid: '410303',
            name: '洛北街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.415238, 34.680639]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410303004',
            ext_path: '河南省 洛阳市 西工区 邙岭路街道',
            cid: '6',
            pid: '410303',
            name: '邙岭路街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.424956, 34.701549]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410303006',
            ext_path: '河南省 洛阳市 西工区 唐宫路街道',
            cid: '7',
            pid: '410303',
            name: '唐宫路街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.448648, 34.677893]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410303001',
            ext_path: '河南省 洛阳市 西工区 王城路街道',
            cid: '8',
            pid: '410303',
            name: '王城路街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.429915, 34.656095]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410303003',
            ext_path: '河南省 洛阳市 西工区 西工街道',
            cid: '9',
            pid: '410303',
            name: '西工街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.448176, 34.663147]
        }
    }
];

export { d };
